<template>
  <footer class="py-4 text-gray-300 border-t bg-dark-footer border-slate-800/70">
    <div class="container flex flex-col items-center justify-between gap-3 text-center md:flex-row">
      <!-- Brand -->
      <a href="#" class="flex items-center gap-2">
        <img
          src="../assets/images/logo-light.png"
          :alt="t('footer_brand_alt')"
          class="w-[140px]"
        />
      </a>

      <!-- Contacts -->
      <div class="flex flex-wrap items-center justify-center gap-3 text-sm">
        <a href="tel:0509212155" class="flex items-center gap-1 transition hover:text-secondary">
          <i class="text-base mdi mdi-phone text-secondary"></i>
          <span>{{ t('footer_phone_label') }}: 0509212155</span>
        </a>
        <span class="text-slate-500">|</span>
        <a href="mailto:hr@mharat.com.sa" class="flex items-center gap-1 transition hover:text-secondary">
          <i class="text-base mdi mdi-email-outline text-secondary"></i>
          <!-- <span>hr@mharat.com.sa</span> -->
          <span>info@smrt-consulting.net</span>

        </a>
        <span class="text-slate-500">|</span>
        <a
          href="https://wa.me/966509212155"
          target="_blank"
          class="flex items-center gap-1 transition hover:text-green-400"
        >
          <i class="text-base text-green-500 mdi mdi-whatsapp"></i>
          <span>{{ t('footer_whatsapp') }}</span>
        </a>
      </div>

      <!-- Social -->
      <div class="flex items-center justify-center gap-2">
        <a
          href="https://linkedin.com"
          target="_blank"
          class="inline-flex items-center justify-center transition rounded-full size-8 bg-white/5 hover:bg-secondary hover:text-primary"
        >
          <i data-feather="linkedin" class="size-4"></i>
        </a>
        <a
          href="https://x.com"
          target="_blank"
          class="inline-flex items-center justify-center transition rounded-full size-8 bg-white/5 hover:bg-secondary hover:text-primary"
        >
          <i data-feather="twitter" class="size-4"></i>
        </a>
        <a
          href="https://www.instagram.com"
          target="_blank"
          class="inline-flex items-center justify-center transition rounded-full size-8 bg-white/5 hover:bg-secondary hover:text-primary"
        >
          <i data-feather="instagram" class="size-4"></i>
        </a>
      </div>
    </div>

    <!-- Rights -->
    <div class="pt-2 text-center text-[12px] text-slate-500">
      {{ t('footer_rights') }} © {{ date }}
      | <span class="text-secondary">{{ t('footer_vision2030') }}</span>
    </div>
  </footer>
  <Switcher />
</template>

<script>
import feather from "feather-icons";
import { messages } from "@/i18n";
import Switcher from "./Switcher.vue";

export default {
   components: { Switcher},
  data() {
    const initial =
      (document.documentElement.lang || localStorage.getItem("app_lang") || "ar").toLowerCase();
    return {
      messages,
      lang: initial.startsWith("en") ? "en" : "ar",
      date: new Date().getFullYear(),
      _langObserver: null,
      _langHandler: null,
    };
  },

  mounted() {
    // Feather icons
    feather.replace();

    // React to navbar broadcast for instant updates
    this._langHandler = (e) => {
      const next = (e.detail || "ar").toLowerCase().startsWith("en") ? "en" : "ar";
      if (next !== this.lang) this.lang = next;
      this.$nextTick(() => feather.replace());
    };
    window.addEventListener("app:lang", this._langHandler, { passive: true });

    // Fallback: watch <html lang/dir>
    this._langObserver = new MutationObserver(() => {
      const htmlLang = (document.documentElement.lang || "ar").toLowerCase();
      const next = htmlLang.startsWith("en") ? "en" : "ar";
      if (next !== this.lang) this.lang = next;
      this.$nextTick(() => feather.replace());
    });
    this._langObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang", "dir"],
    });
  },

  beforeUnmount() {
    if (this._langObserver) this._langObserver.disconnect();
    if (this._langHandler) window.removeEventListener("app:lang", this._langHandler);
  },

  methods: {
    t(key) {
      return (this.messages[this.lang] && this.messages[this.lang][key]) || key;
    },
  },
};
</script>
